module.exports = __webpack_public_path__ + "img/FLOWER HAT LIME.c2e5321.svg";